import CryptoJS from "crypto-js";

function sortEncodeAndHash(objData, key) {
  // console.log("app签名时拿取他的数据----", localStorage.getItem("app"));

  // 获取对象的键并排序
  const sortedKeys = Object.keys(objData).sort();
  // 使用排序后的键生成一个新的对象
  const sortedObj = {};
  sortedKeys.forEach((key) => {
    sortedObj[key] = objData[key];
  });

  let sign = `991701${JSON.stringify(sortedObj)}${
    key ? key : "4C5CBC70C5FF6742D133D93D730D4C96"
  }`;

  console.log("签名信息---", sign);

  // Base64 编码
  const base64Encoded = CryptoJS.enc.Base64.stringify(
    CryptoJS.enc.Utf8.parse(sign)
  );
  // console.log("base64编码后的信息---", base64Encoded);

  // MD5 加密
  const md5Hash = CryptoJS.MD5(base64Encoded).toString(CryptoJS.enc.Hex);
  // console.log("md5加密后的信息---", md5Hash);

  return md5Hash;
}

const simplifySign = (value) => {
  // Base64 编码
  const base64Encoded = CryptoJS.enc.Base64.stringify(
    CryptoJS.enc.Utf8.parse(value)
  );

  // MD5 加密
  const md5Hash = CryptoJS.MD5(base64Encoded).toString(CryptoJS.enc.Hex);

  return md5Hash;
};

const getCurrentDateTime = () => {
  let currentDate = new Date();

  // 获取年、月、日、小时、分钟、秒
  let year = currentDate.getFullYear();
  let month = (currentDate.getMonth() + 1).toString().padStart(2, "0");
  let day = currentDate.getDate().toString().padStart(2, "0");
  let hours = currentDate.getHours().toString().padStart(2, "0");
  let minutes = currentDate.getMinutes().toString().padStart(2, "0");
  let seconds = currentDate.getSeconds().toString().padStart(2, "0");

  // 拼接成 yyyyMMddHHmmss 格式
  let formattedDateTime = `${year}${month}${day}${hours}${minutes}${seconds}`;
  return formattedDateTime;
};

export { sortEncodeAndHash, simplifySign, getCurrentDateTime };
